import http from "../../services/http";

const getAnexos = async () => {
  return await http("get", `v1/anexos/listar`, []);
};

const deleteAnexos = async (id) => {
  return await http("post", `v1/anexos/deletar`, { id: id });
};

const addAnexo = async (formData) => {
  return await http("post", `v1/anexos/cadastrar`, formData, "multipart/form-data");
};

const getAnexoDocumento = async (id) => {
  return await http("file", `v1/anexos/carregar_documento/${id}`, []);
};

export { getAnexos, deleteAnexos, addAnexo, getAnexoDocumento };
